<div class="row">
    <div class="col-md-3">
        <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden" *ngIf="AllCategoryGallery?.length!=0">
            <mat-card-header class="mat-mdc-card-header bg-primary p-10 m-b-15">
                <input class="inputTxt" placeholder="{{ 'search' | translate }}" maxlength="100" #searchVal
                    (change)='checkSearchVal(searchVal.value)' (keyup)="checkSearchVal(searchVal.value)"
                    (keyup.enter)="checkSearchVal(searchVal.value)" />
                <i-tabler name="search" class="icon-20 d-flex icon m-l-6 m-t-6"></i-tabler>
            </mat-card-header>
            <div class="col-md-12">
                <app-slicemenu [DataList]="AllCategoryGallery" [selected]="selectedCategory" [columnName]="'name'"
                    (newItemEvent)="ShowGalleries($event)"></app-slicemenu>
            </div>
        </mat-card>
    </div>
    <div class="col-md-9" *ngIf="GalleriesList">
        <div *ngIf="GalleriesList.length==0;then NoGalleries else Galleries"></div>
        <ng-template #NoGalleries>
            <div class="col-md-12">
                <p> {{ 'NoDataFound' | translate }}</p>
            </div>
        </ng-template>

        <ng-template #Galleries>
            <div class="row">
                <div class="col-lg-12" *ngFor="let gallerylist of GalleriesList">
                    <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
                        <mat-card-header class="mat-mdc-card-header bg-primary p-10 m-b-15">
                            <mat-card-title class="mat-mdc-card-title text-white">
                                <span> {{gallerylist.categoryChildName}}</span>
                            </mat-card-title>
                        </mat-card-header>
                        <mat-card-content class="mat-mdc-card-content text-center">
                            <div class="row">
                                <div class="col-md-3" *ngFor="let gallery of gallerylist.gallery">
                                    <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
                                        <img alt="{{gallery.description}}" width="80" height="80"
                                            src="{{gallery.pathImage | adjust_image_path}}" (click)="ShowImage(gallery)">
                                        <mat-card-content>
                                            <mat-card-title
                                                class="mat-mdc-card-title">{{gallery.description}}</mat-card-title>
                                        </mat-card-content>
                                    </mat-card>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>
        </ng-template>
    </div>
</div>
